import type { FlagsMapper } from '@atlassian/jira-flags';
import { COPY_INITIATE_FAILED } from '../state/actions/copy/index.tsx';
import {
	COPIED,
	COPY_FAILED,
	DELETED,
	DELETE_FAILED,
	type Action as OperationsAction,
} from '../state/actions/operations/index.tsx';
import type { State } from '../state/types.tsx';
import copyError from './copy/error.tsx';
import copied from './copy/success.tsx';
import deleteError from './delete/error.tsx';
import deleted from './delete/success.tsx';
import initiateError from './initiate-copy-modal/error.tsx';

type Action = OperationsAction;

const flagsMapper: FlagsMapper<Action, State> = (action) => {
	switch (action.type) {
		// @ts-expect-error - TS2678 - Type '"state.actions.copy.COPY_INITIATE_FAILED"' is not comparable to type '"state.actions.operations.DELETED" | "state.actions.operations.DELETE_FAILED" | "state.actions.operations.COPIED" | "state.actions.operations.COPY_FAILED"'.
		case COPY_INITIATE_FAILED: {
			return initiateError();
		}

		case COPIED: {
			return copied({ name: action.payload.originalItemName });
		}

		case COPY_FAILED: {
			return copyError(action.payload);
		}

		case DELETED: {
			return deleted(action.payload);
		}

		case DELETE_FAILED: {
			return deleteError(action.payload);
		}
		default: {
			const _exhaustiveCheck: never = action;
			return undefined;
		}
	}
};
export default flagsMapper;
